// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 40) return "css/core.40.5049d13514b86d0b042f.main.css";
	if (chunkId === 179) return "css/core.main.ea151ce6c64ce9169d84.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"405":"cfd","654":"trader","809":"account"}[chunkId] + "." + {"405":"679f5771fac985b270c9","654":"45ad0107a1b3aafcf7c3","809":"4f25e09b5596eea42170"}[chunkId] + ".css";
};